export var PATTERN = {
    NEXT_CELL: '@/NEXT_CELL',
    NEXT_PAGE: '@/NEXT_PAGE'
};
